<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent scrollable max-width=900 content-class="round-2xl")
    v-card
      v-card-text
        div.py-6.px-10.neutral700--text
          .text-xl.font-semibold.mb-4 Save these changes?
          .text-sm.mb-4 These are the changes for received item
          v-data-table(:headers="headers" :items="items" item-key="id" hide-default-footer :items-per-page="itemsPerPage" :page="page")
            template(v-slot:item.stockChanges="{ item }")
              template(v-if="hasReceivedQtyChanges(item)")
                .text-sm {{ item.originalReceivedQty }} → {{ item.receivedQty }} ({{ qtyChangesText(item) }})
              template(v-else)
                .text-sm No changes
            template(v-slot:item.unitCostChanges="{ item }")
              template(v-if="hasCostChanges(item)")
                .text-sm {{ item.originalCost | displayPrice }} → {{ item.costPerItem | displayPrice }}
              template(v-else)
                .text-sm No changes
          .d-flex.justify-end.mt-4
            yc-pagination-custom(v-model="page" :parentPageSize.sync="itemsPerPage" :count="items.length" attach menu-top)
      v-divider
      v-card-actions.px-6
        v-spacer
        v-btn.button-md.neutral700--text.px-0.underline(text @click="handleCancel") {{ $t('cancel') }}
        v-btn.button-md(:loading="isLoading" color="neutral700" depressed dark @click="handleConfirm") {{ $t('confirm') }}
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      isLoading: false,
      itemsPerPage: 10,
      page: 1,
      headers: [
        { text: 'Item', value: 'product.name' },
        { text: 'Stock Changes', value: 'stockChanges' },
        { text: 'Unit Cost Changes', value: 'unitCostChanges' },
      ]
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    handleCancel() {
      this.closeDialog()
      this.$emit('cancel')
    },
    closeDialog() {
      this.$emit('closed')
      this.showDialog = false
    },
    hasReceivedQtyChanges (item) {
      return item.receivedQty !== item.originalReceivedQty
    },
    hasCostChanges (item) {
      return item.costPerItem !== item.originalCost
    },
    qtyChangesText (item) {
      if (!this.hasReceivedQtyChanges(item)) return null

      const changes = item.receivedQty - item.originalReceivedQty
      if (changes > 0) {
        return `+${changes}`
      } else {
        return `${changes}`
      }
    },
    handleConfirm () {
      this.isLoading = true
      this.$emit('confirmed')
    },
    displayFloatCostPrice(integerPrice) {
      return this.$currency.symbol + (integerPrice / this.$currency.multiplier)
    }
  },
}
</script>

<style scoped>
</style>